import React from 'react';
import {useStyles} from './TakisFreeText.styles';
import TakisButton from './TakisButton';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';

export default function TakisFreeText({title, titleColor, paragraphsFirstColumn, paragraphsSecondColumn, paragraphsColor, paragraphsTextAlign, ctas, isSectionTitle}) {
    const isTwoColumns = paragraphsFirstColumn && paragraphsSecondColumn
    const classes = useStyles();

    TakisFreeText.propTypes = {
        title: PropTypes.string.isRequired,
        titleColor: PropTypes.string,
        paragraphsFirstColumn: PropTypes.string.isRequired,
        paragraphsSecondColumn: PropTypes.string,
        paragraphsTextAlign: PropTypes.string,
        paragraphsColor: PropTypes.string,
        ctas: PropTypes.array,
    };

    return (
      <section className={`${classes.freeText}`} data-aos="fade-up">
          {
            isSectionTitle ?
            <h1 className={`${classes.title} ${classes[titleColor] || ''}`}>{title}</h1> :
            <h2 className={`${classes.title} ${classes[titleColor] || ''}`}>{title}</h2>
          }
          <Grid className={`${classes.paragraphsContainer}`} container spacing={isTwoColumns ? 3 : 0}>
              <Grid item xs={12} md={isTwoColumns ? 6 : 12} className={ `${classes[paragraphsTextAlign] || ''}`}>
                  <div className={`${classes.paragraph} ${classes[paragraphsColor] || ''} ${classes[paragraphsTextAlign] || ''}`} dangerouslySetInnerHTML={{__html: paragraphsFirstColumn}}></div>
              </Grid>
              {
                isTwoColumns &&
                <Grid item xs={12} md={6}>
                    <div className={`${classes.paragraph} ${classes.paragraphSecondColumn} ${classes[paragraphsColor] || ''} ${classes[paragraphsTextAlign] || ''}`} dangerouslySetInnerHTML={{__html: paragraphsSecondColumn}}></div>
                </Grid>
              }
          </Grid>
          {
            ctas &&
            <div className={`${classes.ctasContainer}`}>
              {
                ctas.map((cta) => {
                  return <TakisButton
                    key={`freetext-cta-${cta.title.trim()}${cta.href}`}
                    title={cta.title}
                    alt={cta.alt}
                    href={cta.href}
                    ariaLabel={cta.ariaLabel}
                    color={cta.color || "purpleButton"}
                    orientation={cta.orientation}
                  />
                })
              }
            </div>
          }
      </section>
  );
}

